import script from "./UserAccountBinding.vue?vue&type=script&setup=true&lang=js"
export * from "./UserAccountBinding.vue?vue&type=script&setup=true&lang=js"

import "@/features/user/styles/operationArea/UserAccountBinding.css?vue&type=style&index=0&id=4e4bacab&scoped=true&lang=css&external"
import "@/features/user/styles/operationArea/OperationAreaTheme.css?vue&type=style&index=1&id=4e4bacab&scoped=true&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e4bacab"]])

export default __exports__